<template>
    <div class="col-md-12">
        <page-title :title="$t('annualCatalog.annualCatalogProject')" :showTitle="false"></page-title>

        <div class="loader" v-if="loading"></div>
        <div v-else>
            <div class="alert alert-danger" v-if="annualCatalogProject.hasCreatedAnnualCatalogForTheYear">{{
                $t('annualCatalog.thereIsCreatedAnnualCatalog') }} {{ annualCatalogProject.year }} {{
                $t('annualCatalog.year') }}
            </div>
            <div class="card">
                <div class="card-header bg-primary text-white">
                    <div class="h5">{{ $t('planning.planning') }} - {{ annualCatalogProject.year }}</div>
                </div>
                <div class="card-body">
                    <table class="table table-bordered">
                        <thead>
                        <tr>
                            <th>{{ $t('planning.includeInAnnualCatalog') }}</th>
                            <th>{{ $t('annualCatalog.approved') }}</th>
                            <th class="required">{{ $t('planning.theme') }}</th>
                            <th class="required" style="width: 20%; max-width: 20%;">{{ $t('thematicArea.thematicArea') }}
                            </th>
                            <th class="required" width="20%">{{ $t('planning.legalArea') }}</th>
                            <th>{{ $t('planning.lectorsProposal') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item of annualCatalogProject.items">
                            <td>
                                <toggle v-model="item.includeInAnnualCatalog"
                                        :disabled="annualCatalogProject.hasCreatedAnnualCatalogForTheYear"></toggle>
                            </td>
                            <td>{{ item.approvedUser }}</td>
                            <td>{{ item.theme }}</td>
                            <td>{{ item.thematicArea }}</td>
                            <td>{{ item.legalArea }}</td>
                            <td>
                                <div v-if="item.lectors" v-for="lector in item.lectors">
                                    {{ lector.fullName }}
                                </div>
                            </td>
                        </tr>
                        </tbody>
                        <tfoot v-if="!annualCatalogProject.hasCreatedAnnualCatalogForTheYear">
                        <tr colspan="6">
                            <td>
                                <button v-if="hasCreateRights || hasEditRights" class="btn btn-primary"
                                        @click="onSave">{{ $t('save') }}
                                </button>
                                <button v-if="hasCreateRights || hasEditRights" class="btn btn-primary"
                                        @click="onCreateAnnualCatalog">{{ $t('planning.addToAnnualCatalog') }}
                                </button>
                            </td>
                        </tr>
                        </tfoot>
                    </table>
                    <div class="col-md-12 mb-3" v-if="hasCreateRights">
                        <button class="btn btn-primary" data-toggle="modal" data-target="#createModal">
                            {{$t('annualCatalog.coordination')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <CreateModal @created="onCreate" :value="createModel" @onClose="onModalClose" ref="createModal"></CreateModal>
    </div>
</template>

<script>
    import {AnnualCatalogProjectModel, Coordination} from '../../models/models';
    import PageTitle from '../../components/common/PageTitle';
    import Toggle from '../../components/toggle/Toggle';
    import CreateModal from '../../components/coordinations/create.modal';

    export default {
        components: {
            PageTitle,
            Toggle,
            CreateModal,
        },
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data() {
            return {
                loading: false,
                annualCatalogProject: new AnnualCatalogProjectModel(),
                createModel: null,
            }
        },
        methods: {
            loadData() {
                this.loading = true;
                this.$http.get(`/api/AnnualCatalogProject/GetById/${this.id}`).then(result => {
                    this.loading = false;
                    this.annualCatalogProject = new AnnualCatalogProjectModel(result.data);
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$t('notifications.errorDataNotSaved'),
                        position: 'top-center',
                        color: 'danger'
                    });
                });
            },
            onSave() {
                if (!this.hasCreateRights && !this.hasEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.loading = true;
                this.$http.put('/api/AnnualCatalogProject/Edit', this.annualCatalogProject).then(result => {
                    this.loadData();
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$t('notifications.errorDataNotSaved'),
                        position: 'top-center',
                        color: 'danger'
                    });
                });
            },
            onCreateAnnualCatalog() {
                if (!this.hasCreateRights && !this.hasEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.loading = true;
                this.$http.post('/api/AnnualCatalog/Create', this.annualCatalogProject).then(result => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                    this.$router.push(`/annualcatalog/details/${result.data}`);
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$t('notifications.errorDataNotSaved'),
                        position: 'top-center',
                        color: 'danger'
                    });
                });
            },
            onCreate() {
                this.loadData();
            },
            onModalClose() {
                this.createTaskObject();
            },
            createTaskObject(){
                this.createModel = new Coordination({
                    title: this.$t('planning.planning') + ' - '+ this.annualCatalogProject.year ,
                    itemLink: window.location.href
                });
            }
        },
        mounted() {
            const routeId = this.$route.params.id;
            if (routeId) {
                this.id = routeId;
            }

            this.loadData();
        },
        computed: {
            hasCreateRights() {
                return this.$store.getters.claims.annualCatalogProject.create;
            },
            hasEditRights() {
                return this.$store.getters.claims.annualCatalogProject.update;
            },
        },
        watch:{
            'annualCatalogProject.year'(newVal){
                if (newVal){
                    this.createTaskObject();
                }
            }
        }
    }
</script>
